
<template>
    <div class="Background">
        <div class="link_location">
            <h2 class="Title">
                {{ $store.getters.t ? $store.getters.t('설정') : '설정' }}
                <v-icon class="mdi mdi-chevron-right" />
                <span style="color: rgb(29, 120, 211); font-weight: bold;">
                    {{ $store.getters.t('social.integration.title') }}
                </span>
            </h2>
        </div>
        <SocialConnected v-if="canUseSocialIntegration" />
        <v-card v-else class="permission-locked-card elevation-0 pa-8 text-center">
            <v-icon size="48" color="grey darken-1" class="mb-4">mdi-lock</v-icon>
            <h3 class="mb-2">
                {{ $store.getters.t('social.integration.locked.title') }}
            </h3>
            <p class="mb-0">
                {{ $store.getters.t('social.integration.locked.description') }}
            </p>
        </v-card>
    </div>
</template>

<script>
import SocialConnected from '@/components/socialupload/SocialConnectForm.vue';

export default {
    components: {
        SocialConnected,
    },
    computed: {
        canUseSocialIntegration() {
            return this.$store.getters['naviList/hasSocialIntegration'];
        }
    }
}
</script>

<style scoped>
.permission-locked-card {
    background-color: #f5f7fb;
}
</style>
